<template>
  <v-container fluid>
    <Header></Header>
    <router-view v-show="scrollToTop"/>
    <Footer></Footer>
  </v-container>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import PremiumApi from '@/plugins/axios';

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm;
    PremiumApi.getMasterData(function (data) {
      vm.$store.dispatch("saveMasterData", data)
    });
  },
  computed: {
    scrollToTop () {
      if (this.$route.name !== '') { window.scrollTo(0, 0) }
      return true
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/utility.scss";
@import "@/assets/css/style.scss";
@import "@/assets/css/icon.scss";
</style>
